module.exports = __webpack_public_path__ + "img/targeted-opportunities.5c44da6c.svg";